import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import { reorder } from '../../../functions'

import ListGroup from './list-group'
import ListItem from './list-item'

class List extends Component {
  constructor(props) {
    super(props)

    this.state = {
      items: []
    }
  }

  componentWillMount() {
    const { items } = this.props

    this.setState({items})
  }

  componentWillUpdate(nextProps, nextState) {
    const { items } = nextProps

    if (items !== this.props.items) this.setState({items})
  }

  reorderList = (result) => {
    if (!result.destination) return null

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    )

    this.setState({items}, () => this.props.moveRiderItem({id: result.draggableId, position: result.destination.index+1}))
  }

  render() {
    const { view, columns, stageElements } = this.props
    const { items } = this.state

    return (
      <div className="list">
        <DragDropContext onDragEnd={this.reorderList}>
          <Droppable droppableId="list" isDropDisabled={!view.editable} type="instrument">
            {(provided, snapshot) => (
              <div className="list--droppable"
                ref={provided.innerRef} >
                {
                  items.length > 0
                  ? items.map((item, index) => {
                      // if (item.id === undefined) return <Loading key={index} className="list-item list-item--loading" />

                      if (item.class.includes('instrument')) {
                        return item.class === 'instrument-group'
                        ? <ListGroup key={item.id || index}
                            view={view}
                            dragDropType={`instrument-group-${item.id}`}
                            group={this.props.group}
                            columns={columns}
                            item={item}
                            itemIndex={index}
                            itemGroups={this.props.itemGroups}
                            createRiderColumn={this.props.createRiderColumn}
                            addRiderItem={this.props.addRiderItem}
                            removeRiderItem={this.props.removeRiderItem}
                            createRiderItem={this.props.createRiderItem}
                            createRiderItems={this.props.createRiderItems}
                            editRiderItem={this.props.editRiderItem}
                            deleteRiderItem={this.props.deleteRiderItem}
                            stageElements={stageElements}
                            createStageElement={this.props.createStageElement}
                            getSearchResults={this.props.getSearchResults} />
                        : <ListItem key={item.id || index}
                            view={view}
                            dragDropType="instrument"
                            group={this.props.group}
                            columns={columns}
                            item={item}
                            itemIndex={index}
                            itemGroups={this.props.itemGroups}
                            position={item.position}
                            required={item.required}
                            createRiderColumn={this.props.createRiderColumn}
                            addRiderItem={this.props.addRiderItem}
                            removeRiderItem={this.props.removeRiderItem}
                            createRiderItem={this.props.createRiderItem}
                            editRiderItem={this.props.editRiderItem}
                            deleteRiderItem={this.props.deleteRiderItem}
                            stageElements={stageElements}
                            createStageElement={this.props.createStageElement}
                            getSearchResults={this.props.getSearchResults} />
                      } else {
                        return null
                      }
                    })
                  : view.editable
                    ? <p>Start by adding your <a onClick={() => {
                        this.props.addRiderItem({
                          class: "instrument",
                          position: items.length+1,
                          indexes: [
                            items.length
                          ]
                        })
                      }}>first instrument</a>.</p>
                    : <p>This rider has no instruments</p>
                }

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        {
          view.editable
          ? <button className="list--add-button button--link" onClick={() => {
              this.props.addRiderItem({
                class: "instrument",
                position: items.length+1,
                indexes: [
                  items.length
                ]
              })
            }}>
              Insert instrument
            </button>
          : null
        }
      </div>
    )
  }
}

List.propTypes = {
  view: PropTypes.object,
  group: PropTypes.string,
  columns: PropTypes.array,
  items: PropTypes.array,
  itemGroups: PropTypes.array,
  createRiderColumn: PropTypes.func,
  addRiderItem: PropTypes.func,
  removeRiderItem: PropTypes.func,
  createRiderItem: PropTypes.func,
  createRiderItems: PropTypes.func,
  editRiderItem: PropTypes.func,
  moveRiderItem: PropTypes.func,
  deleteRiderItem: PropTypes.func,
  stageElements: PropTypes.object,
  createStageElement: PropTypes.func,
  getSearchResults: PropTypes.func
}

List.defaultProps = {
  view: {},
  group: '',
  columns: [],
  items: [],
  itemGroups: [],
  createRiderColumn: function() {},
  addRiderItem: function() {},
  removeRiderItem: function() {},
  createRiderItem: function() {},
  createRiderItems: function() {},
  editRiderItem: function() {},
  moveRiderItem: function() {},
  deleteRiderItem: function() {},
  stageElements: {},
  createStageElement: function() {},
  getSearchResults: function() {}
}

export default List



// WEBPACK FOOTER //
// ./src/components/rider/rider-input/input-list/list.js